class Diagnosis {
  constructor() {
    this.diagnosisEls = document.querySelectorAll('.js-diagnosis');
    this.activeClassName = 'is-active';
    this.showClassName = 'is-show';
    this.hideClassName = 'is-hide';
    this.leavingClassName = 'is-question-out';
    this.enteringClassName = 'is-question-in';
    this.init();
  }

  init() {
    if (!this.diagnosisEls.length) return;
    const diagnosisCount = this.diagnosisEls.length;

    this.diagnosisEls.forEach((diagnosis, diagnosisIndex) => {
      this.assignDiagnosisIndex(diagnosis, diagnosisIndex, diagnosisCount);
      this.reassignQuestionInputs(diagnosis, diagnosisIndex);

      const diagnosisType = diagnosis.dataset.type || 'default';

      if (diagnosisType === 'diagnosis3') {
        this.initDiagnosis3(diagnosis, diagnosisIndex);
      } else if (diagnosisType === 'diagnosis4') {
        this.initDiagnosis4(diagnosis, diagnosisIndex);
      } else {
        this.initDefault(diagnosis, diagnosisIndex);
      }
    });
  }

  initDefault(diagnosis, diagnosisIndex) {
    const history = [];

    diagnosis.addEventListener('change', (e) => {
      const trigger = e.target;
      if (!trigger.classList.contains('js-diagnosis-trigger')) return;

      const nextId = trigger.dataset.next;
      const currentPanel = trigger.closest('[data-id]');
      if (!currentPanel) return;
      const nextPanel = diagnosis.querySelector(`[data-id="${nextId}"]`);
      if (!nextPanel) return;

      if (nextPanel.classList.contains('js-diagnosis-answer')) {
        // 設問は非表示にせず、結果とボタンを表示
        this.showResult(nextPanel, diagnosis, history);
      } else {
        // 設問間の遷移: フェードアウト → フェードイン
        history.push(currentPanel.dataset.id);
        this.transitionQuestion(currentPanel, nextPanel);
        this.updateBackButton(diagnosis, history);
      }
    });

    diagnosis.addEventListener('click', (e) => {
      if (e.target.closest('.js-diagnosis-retry-trigger')) {
        history.length = 0;
        this.reset(diagnosis, history);
      }
      if (e.target.closest('.js-diagnosis-question-back-trigger')) {
        this.goBack(diagnosis, history);
      }
    });
  }

  initDiagnosis3(diagnosis, diagnosisIndex) {
    const answerHistory = [];
    const history = [];

    diagnosis.addEventListener('change', (e) => {
      const trigger = e.target;
      if (!trigger.classList.contains('js-diagnosis-trigger')) return;

      // Value を記録
      if (trigger.checked && trigger.value) {
        answerHistory.push(trigger.value);
      }

      const nextId = trigger.dataset.next;
      const currentPanel = trigger.closest('[data-id]');
      if (!currentPanel) return;

      // 最終問判定: data-next="result" の場合
      if (nextId === 'result') {
        // 全設問完了: answerHistory を連結して結果を表示
        const responseKey = answerHistory.join('');
        this.showDiagnosis3Result(diagnosis, responseKey, history);
      } else {
        const nextPanel = diagnosis.querySelector(`[data-id="${nextId}"]`);
        if (!nextPanel) return;
        // 設問間の遷移: フェードアウト → フェードイン
        history.push(currentPanel.dataset.id);
        this.transitionQuestion(currentPanel, nextPanel);
        this.updateBackButton(diagnosis, history);
      }
    });

    diagnosis.addEventListener('click', (e) => {
      if (e.target.closest('.js-diagnosis-retry-trigger')) {
        answerHistory.length = 0;
        history.length = 0;
        this.resetDiagnosis3(diagnosis, history);
      }
      if (e.target.closest('.js-diagnosis-question-back-trigger')) {
        if (answerHistory.length > 0) {
          answerHistory.pop();
        }
        this.goBack(diagnosis, history);
      }
    });
  }

  initDiagnosis4(diagnosis, diagnosisIndex) {
    const answerHistory = [];
    const history = [];

    diagnosis.addEventListener('change', (e) => {
      const trigger = e.target;
      if (!trigger.classList.contains('js-diagnosis-trigger')) return;

      if (trigger.checked && trigger.value) {
        answerHistory.push(trigger.value);
      }

      const nextId = trigger.dataset.next;
      const currentPanel = trigger.closest('[data-id]');
      if (!currentPanel) return;

      if (nextId === 'result') {
        // 全設問完了: 判定ロジックで結果を決定
        console.log('Answer History:', answerHistory);
        this.showDiagnosis4Result(diagnosis, answerHistory, history);
      } else {
        const nextPanel = diagnosis.querySelector(`[data-id="${nextId}"]`);
        if (!nextPanel) return;
        history.push(currentPanel.dataset.id);
        this.transitionQuestion(currentPanel, nextPanel);
        this.updateBackButton(diagnosis, history);
      }
    });

    diagnosis.addEventListener('click', (e) => {
      if (e.target.closest('.js-diagnosis-retry-trigger')) {
        answerHistory.length = 0;
        history.length = 0;
        this.reset(diagnosis, history);
      }
      if (e.target.closest('.js-diagnosis-question-back-trigger')) {
        if (answerHistory.length > 0) {
          answerHistory.pop();
        }
        this.goBack(diagnosis, history);
      }
    });
  }

  showDiagnosis3Result(diagnosis, responseKey, history) {
    // ラジオを無効化
    diagnosis.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.disabled = true;
    });

    // 戻るボタンを非表示
    history.length = 0;
    this.updateBackButton(diagnosis, history);

    const questionContent = diagnosis.querySelector('.js-diagnosis-content-question');
    if (questionContent) questionContent.classList.add(this.hideClassName);

    // data-response に responseKey が含まれている結果ブロックを表示
    const answerBlocks = diagnosis.querySelectorAll('.js-diagnosis-answer');
    answerBlocks.forEach((block) => {
      const dataResponse = block.getAttribute('data-response') || '';
      const responses = dataResponse.split(',').map((r) => r.trim());

      if (responses.includes(responseKey)) {
        block.classList.add(this.showClassName);
      }
    });

    const retryContainers = diagnosis.querySelectorAll('.js-diagnosis-retry-container');
    retryContainers.forEach((container) => container.classList.add(this.showClassName));
  }

  showDiagnosis4Result(diagnosis, answerHistory, history) {
    // 評価関数を取得
    const evaluatorScript = diagnosis.querySelector('.js-diagnosis-evaluator');
    if (!evaluatorScript) return;

    let evaluator;

    try {
      const counts = this.countAnswers(answerHistory);
      const conditionCode = evaluatorScript.textContent;
      const func = new Function('counts', conditionCode);
      const resultId = func(counts);

      if (!resultId) return;

      diagnosis.querySelectorAll('.js-diagnosis-trigger').forEach(r => r.disabled = true);
      history.length = 0;
      this.updateBackButton(diagnosis, history);

      const questionContent = diagnosis.querySelector('.js-diagnosis-content-question');
      if (questionContent) questionContent.classList.add(this.hideClassName);

      const resultBlock = diagnosis.querySelector(`[data-id="${resultId}"]`);
      if (resultBlock) resultBlock.classList.add(this.showClassName);

      const retryContainers = diagnosis.querySelectorAll('.js-diagnosis-retry-container');
      retryContainers.forEach((container) => container.classList.add(this.showClassName));
    } catch (error) {
      console.error('診断評価ロジックの解析に失敗:', error);
    }

  }

  countAnswers(answerHistory) {
    const counts = { A: 0, B: 0, C: 0, D: 0 };
    answerHistory.forEach((answer) => {
      if (counts.hasOwnProperty(answer)) {
        counts[answer]++;
      }
    });
    return counts;
  }

  resetDiagnosis3(diagnosis, history) {
    const questions = diagnosis.querySelectorAll('.js-diagnosis-question');
    const answers = diagnosis.querySelectorAll('.js-diagnosis-answer');
    const retryContainer = diagnosis.querySelector('.js-diagnosis-retry-container');

    // 設問リセット: 最初の設問のみ表示
    questions.forEach((q, i) => {
      q.classList.remove(this.activeClassName, this.leavingClassName, this.enteringClassName);
      if (i === 0) q.classList.add(this.activeClassName);
    });

    // 結果を非表示
    answers.forEach((a) => a.classList.remove(this.showClassName));

    // ボタンコンテナを非表示
    if (retryContainer) retryContainer.classList.remove(this.showClassName);

    // 戻るボタンを非表示
    this.updateBackButton(diagnosis, history);

    // 設問エリアを再表示
    const questionContent = diagnosis.querySelector('.js-diagnosis-content-question');
    if (questionContent) questionContent.classList.remove(this.hideClassName);

    // ラジオをリセット・再有効化
    diagnosis.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.checked = false;
      r.disabled = false;
    });

    setTimeout(() => {
      if (!retryContainer) return;
      const retryButton = retryContainer.querySelector('.js-diagnosis-retry-trigger');
      if (!retryButton) return;
      const adjustDistance = parseInt(retryButton.getAttribute('data-distance'), 10) || 0;
      const scrollVolume = diagnosis.getBoundingClientRect().top + window.scrollY - adjustDistance;
      window.scrollTo({ top: scrollVolume, behavior: 'smooth' });
    }, 10);
  }

  assignDiagnosisIndex(diagnosis, diagnosisIndex, diagnosisCount) {
    diagnosis.dataset.diagnosisIndex = String(diagnosisIndex);
    diagnosis.dataset.diagnosisCount = String(diagnosisCount);
  }

  reassignQuestionInputs(diagnosis, diagnosisIndex) {
    const questions = diagnosis.querySelectorAll('.js-diagnosis-question');

    questions.forEach((question, questionIndex) => {
      const triggers = question.querySelectorAll('.js-diagnosis-trigger');
      const nextName = `diagnosis-${diagnosisIndex}-q${questionIndex}`;

      triggers.forEach((trigger, triggerIndex) => {
        const oldId = trigger.id;
        const nextId = `diagnosis-${diagnosisIndex}-q${questionIndex}-r${triggerIndex}`;

        trigger.id = nextId;
        trigger.name = nextName;

        if (oldId) {
          diagnosis.querySelectorAll(`label[for="${oldId}"]`).forEach((label) => {
            label.setAttribute('for', nextId);
          });
        }

        const wrappingLabel = trigger.closest('label');
        if (wrappingLabel) {
          wrappingLabel.setAttribute('for', nextId);
        }
      });
    });
  }

  transitionQuestion(currentPanel, nextPanel) {
    currentPanel.classList.add(this.leavingClassName);
    currentPanel.addEventListener(
      'animationend',
      () => {
        currentPanel.classList.remove(this.activeClassName, this.leavingClassName);
        nextPanel.classList.add(this.activeClassName, this.enteringClassName);
        nextPanel.addEventListener(
          'animationend',
          () => {
            nextPanel.classList.remove(this.enteringClassName);
          },
          { once: true }
        );
      },
      { once: true }
    );
  }

  showResult(panel, diagnosis, history) {
    // 結果表示後はラジオを無効化して再トリガーを防ぐ
    diagnosis.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.disabled = true;
    });

    // 戻るボタンを非表示
    history.length = 0;
    this.updateBackButton(diagnosis, history);

    const retryContainer = diagnosis.querySelector('.js-diagnosis-retry-container');

    const questionContent = diagnosis.querySelector('.js-diagnosis-content-question');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (questionContent) questionContent.classList.add(this.hideClassName);
        panel.classList.add(this.showClassName);
        if (retryContainer) retryContainer.classList.add(this.showClassName);
      });
    });
  }

  updateBackButton(diagnosis, history) {
    const backContainer = diagnosis.querySelector('.js-diagnosis-question-back-container');
    if (!backContainer) return;
    backContainer.classList.toggle(this.showClassName, history.length > 0);
  }

  goBack(diagnosis, history) {
    if (history.length === 0) return;
    const prevId = history.pop();
    const currentPanel = diagnosis.querySelector('.js-diagnosis-question.is-active');
    const prevPanel = diagnosis.querySelector(`[data-id="${prevId}"]`);
    if (!currentPanel || !prevPanel) return;

    currentPanel.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.checked = false;
    });

    prevPanel.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.checked = false;
    });

    this.transitionQuestion(currentPanel, prevPanel);
    this.updateBackButton(diagnosis, history);
  }

  reset(diagnosis, history) {
    const questions = diagnosis.querySelectorAll('.js-diagnosis-question');
    const answers = diagnosis.querySelectorAll('.js-diagnosis-answer');
    const retryContainer = diagnosis.querySelector('.js-diagnosis-retry-container');

    // 設問リセット: 最初の設問のみ表示
    questions.forEach((q, i) => {
      q.classList.remove(this.activeClassName, this.leavingClassName, this.enteringClassName);
      if (i === 0) q.classList.add(this.activeClassName);
    });

    // 結果を非表示
    answers.forEach((a) => a.classList.remove(this.showClassName));

    // ボタンコンテナを非表示
    if (retryContainer) retryContainer.classList.remove(this.showClassName);

    // 戻るボタンを非表示
    this.updateBackButton(diagnosis, history);

    // 設問エリアを再表示
    const questionContent = diagnosis.querySelector('.js-diagnosis-content-question');
    if (questionContent) questionContent.classList.remove(this.hideClassName);

    // ラジオをリセット・再有効化
    diagnosis.querySelectorAll('.js-diagnosis-trigger').forEach((r) => {
      r.checked = false;
      r.disabled = false;
    });

    setTimeout(() => {
      if (!retryContainer) return;
      const retryButton = retryContainer.querySelector('.js-diagnosis-retry-trigger');
      if (!retryButton) return;
      const adjustDistance = parseInt(retryButton.getAttribute('data-distance'), 10) || 0;
      const scrollVolume = diagnosis.getBoundingClientRect().top + window.scrollY - adjustDistance;
      window.scrollTo({ top: scrollVolume, behavior: 'smooth' });
    }, 10);
  }
}

export default Diagnosis;
